import feathersClient from "../../feathers-client";

const defaultFilledShiftReasonPagination = {
    total: 100,
    $skip: 0,
    $limit: 10,
};
const defaultFilledShiftReasonPaginationFilter = {
    $skip: defaultFilledShiftReasonPagination.$skip,
    $limit: defaultFilledShiftReasonPagination.$limit
};

export default {
    state: {
        filledShiftReason: [],
        filledShiftReasonPagination: defaultFilledShiftReasonPagination,
        filledShiftReasonFilter: defaultFilledShiftReasonPaginationFilter
    },
    getters: {
        setFilledShiftReasonPage: (state) => {
            const { $limit, $skip } = state.filledShiftReasonPagination;
            return $skip / $limit + 1;
        }
    },
    mutations: {
        SET_FILLED_SHIFT_REASON: (state, data) => { state.filledShiftReason = data; },
        SET_FILLED_SHIFT_PAGINATION: (state, data) => { state.filledShiftReasonPagination = { ...state.filledShiftReasonPagination, ...data }; },
        SET_FILLED_SHIFT_PAGINATION_FILTER: (state, data) => { state.filledShiftReasonPaginationFilter = { ...state.filledShiftReasonPaginationFilter, ...data }; }
    },
    actions: {
        setFilledShiftReasonListPage: ({ commit, state }, page) => {
            const $skip = (page - 1) * state.filledShiftReasonPagination.$limit;
            commit('SET_FILLED_SHIFT_PAGINATION', { $skip });
            commit('SET_FILLED_SHIFT_PAGINATION_FILTER', { $skip });
        },

        getFilledShiftReason: async ({ rootGetters, commit }, filter) => {
            const results = await feathersClient.service('api/v3/filled-shift-reasons').find({
                query: {
                    $role: rootGetters.currentUserRole, // Removed $ prefix
                    ...filter
                }
            });
           
            commit('SET_FILLED_SHIFT_REASON', results.data);
            commit('SET_FILLED_SHIFT_PAGINATION', { total: results.total })
           
            return results.data;
        },
        createFilledShiftReason: async ({ rootGetters, commit }, data) => {
            const results = await feathersClient.service('api/v3/filled-shift-reasons').create(data, {
                query: {
                    $role: rootGetters.currentUserRole, // Removed $ prefix
                },
            });
            return results;
        },
        updateFilledShiftReason: async ({ rootGetters, commit }, data) => {
            const results = await feathersClient.service('api/v3/filled-shift-reasons').patch(data.id, data, {
                query: {
                   $role: rootGetters.currentUserRole, // Removed $ prefix
                },
            });
            return results;
        },
        deleteFilledShiftReason: async ({ rootGetters}, id) => {
            const results = await feathersClient.service('api/v3/filled-shift-reasons').remove(id, {
                query: {
                   $role: rootGetters.currentUserRole, // Removed $ prefix
                },
            });
            return results;
        },
        getFilledShiftReasonById: async ({ rootGetters }, id) => {
            const results = await feathersClient.service('api/v3/filled-shift-reasons').get(id, {
                query: {
                  $role: rootGetters.currentUserRole, // Removed $ prefix
                },
            });
             
            return results
        },
        getAllFilledShiftReasonForTrust: async ({ rootGetters }) => {
            const results = await feathersClient.service('api/v3/filled-shift-reasons').find({
                query: {
                   $role: rootGetters.currentUserRole, // Removed $ prefix
                },
            });
            return results;
        },
        getAllFilledShiftReason: async ({ rootGetters }) => {
            const results = await feathersClient.service('api/v3/filled-shift-reasons').find({
                query: {
                 $role: rootGetters.currentUserRole, // Removed $ prefix
                },
            });
            return results.data;
        }
    }
}